import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

var HintFilled = function HintFilled(props) {
  var rtlStyle = {
    transform: 'scale(-1, 1)'
  };
  var _props$color = props.color,
      color = _props$color === void 0 ? 'currentColor' : _props$color,
      size = props.size,
      _props$dir = props.dir,
      dir = _props$dir === void 0 ? 'ltr' : _props$dir,
      style = props.style;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: dir === 'rtl' ? _extends({}, style, rtlStyle) : _extends({}, style)
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11.6375 13.995C11.1335 13.995 10.8573 13.6549 10.8573 13.2013C10.8573 12.365 11.1818 11.8901 12.1139 11.1389C12.7837 10.6003 13.1565 10.2601 13.1565 9.63643C13.1565 8.94188 12.5558 8.48122 11.7963 8.48122C11.1335 8.48122 10.6778 8.74344 10.3464 9.32459C10.1323 9.61517 9.96663 9.74982 9.67664 9.74982C9.24166 9.74982 9 9.4309 9 9.04111C9 8.57335 9.26927 8.07725 9.68354 7.70163C10.1876 7.26223 10.9402 7 11.9206 7C13.7365 7 15 7.97094 15 9.55138C15 10.6499 14.4131 11.2523 13.5293 11.9256C12.8596 12.45 12.6318 12.6981 12.473 13.2934C12.3003 13.7116 12.1208 13.995 11.6375 13.995ZM11.6375 17C11.0644 17 10.5949 16.5889 10.5949 16.0007C10.5949 15.4125 11.0644 15.0014 11.6375 15.0014C12.2106 15.0014 12.687 15.4125 12.687 16.0007C12.687 16.5889 12.2106 17 11.6375 17Z",
    fill: color
  }));
};

export { HintFilled };
